var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [_c("b-list-group", [_c("Menu")], 1)],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [_c("h4", [_vm._v(":: Clientes")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-link",
                                { attrs: { href: "/clients-by-brands" } },
                                [_vm._v("Clientes por marcas")]
                              ),
                              _vm._v(" » "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href:
                                      "/clients-by-brands/" +
                                      this.$route.params.brand
                                  }
                                },
                                [
                                  _vm._v(
                                    "Lista de clientes " +
                                      _vm._s(this.$route.params.brand)
                                  )
                                ]
                              ),
                              _vm._v(
                                " » " +
                                  _vm._s(_vm.client.fullname) +
                                  ":\n              "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        { staticClass: "mb-4", on: { submit: _vm.onSubmit } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_first_name",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Nombre"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "first_name", state: _vm.state },
                                model: {
                                  value: _vm.client.first_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "first_name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.first_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_last_name",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Apellidos"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "last_name", state: _vm.state },
                                model: {
                                  value: _vm.client.last_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "last_name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.last_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_dni",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "DNI"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "dni", state: _vm.state },
                                model: {
                                  value: _vm.client.rut_w2l,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "rut_w2l",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.rut_w2l"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_phone",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Teléfono"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "phone", state: _vm.state },
                                model: {
                                  value: _vm.client.fone1_w2l,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "fone1_w2l",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.fone1_w2l"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_email",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Correo electrónico"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "email", state: _vm.state },
                                model: {
                                  value: _vm.client.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_cc_destino",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "CC_DESTINO"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "cc_destino", state: _vm.state },
                                model: {
                                  value: _vm.client.cc_destino,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "cc_destino",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.cc_destino"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_local",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Local"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "local_w2l", state: _vm.state },
                                model: {
                                  value: _vm.client.local_w2l,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "local_w2l",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.local_w2l"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary derco"
                              }
                            },
                            [_vm._v("Actualizar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54dff625", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dff625","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditClient.vue
// module id = null
// module chunks = 